module.exports = __webpack_public_path__ + "static/media/mspa-poc-new-user.432b8da2.png";